document.addEventListener('DOMContentLoaded', () => {
   document.addEventListener('change', function (event) {
        if (!event.target.matches('.cart-quantity-select')) return;

        const cartDrawer = document.querySelector('cart-drawer');

        // if (cartDrawer) {
        // const section = event.target.closest('cart-drawer-items');
        // if (section && typeof section.onChange === 'function') {
        //     section.onChange(event);
        //     return;
        // }
        // }

        // const form = event.target.closest('form');
        // if (form) form.requestSubmit();
        event.preventDefault();
        event.stopPropagation();
    });


    window.bindCartDrawerOverlay = function() {
        const cartDrawer = document.querySelector('cart-drawer'); // target the <cart-drawer> element
        if (!cartDrawer) return;

        const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
        if (!overlay) return;

        // Remove previous listeners to avoid duplicates
        overlay.replaceWith(overlay.cloneNode(true));

        const newOverlay = cartDrawer.querySelector('#CartDrawer-Overlay');
        newOverlay.addEventListener('click', () => {
            cartDrawer.classList.remove('active');
            document.body.classList.remove('overflow-hidden');
        });
    }   
});


// Detect drawer open/refresh
function watchCartDrawer() {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer) return;

    const observer = new MutationObserver(() => {
        if (drawer.classList.contains("active") || drawer.hasAttribute("open")) {
            // Drawer opened
            document.dispatchEvent(new Event("cart:updated"));
        }
    });

    observer.observe(drawer, { attributes: true, attributeFilter: ["class", "open"] });
}

document.addEventListener("DOMContentLoaded", watchCartDrawer);


/************ CART FEATURES INIT ************/
document.addEventListener("DOMContentLoaded", () => {
  initCartFeatures();

  document.addEventListener("cart:updated", () => {
    initCartFeatures();
  });
});

document.addEventListener("focusin", function(event) {
  if (event.target.matches('.cart-quantity-select')) {
    event.target.dataset.prev = event.target.value; // store previous quantity
  }
});

function initCartFeatures() {
    document.removeEventListener("change", cartQuantityHandler);
    document.addEventListener("change", cartQuantityHandler);
}

/************ CART QUANTITY CHANGE HANDLER ************/
function cartQuantityHandler(event) {
    if (!event.target.matches('.cart-quantity-select')) return;

    const select = event.target;
    const prevQty = Number(select.dataset.prev);   // saved quantity
    const newQty  = Number(select.value);
    const key     = select.dataset.line;           // item.key

  if (!key) return;

    if (!key) return;

    fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: key,       // changed!
            quantity: newQty
        })
    })
    .then(res => res.json())
    .then(data => {
        if (data.status && data.message) {
            showLineItemError(key, data.message);
            select.value = prevQty;
            return;
        }
        clearLineItemError(key);
        document.dispatchEvent(new Event("cart:updated"));
    })
    .catch(console.error);
}

function showLineItemError(key, message) {
    const el = document.querySelector(`.cart-line-error[data-line-error="${key}"]`);
    if (el) {
        el.textContent = message;
        el.style.display = "block";
    }
}

    function clearLineItemError(key) {
        const el = document.querySelector(`.cart-line-error[data-line-error="${key}"]`);
        if (el) {
            el.textContent = "";
            el.style.display = "none";
        }
    }

  // Countdown Timer (example 12 hours)       
  function getStoreEndTime(dateString) {
    if (!dateString) return null;
    // Convert to ISO with Pacific offset
    const isoString = dateString.replace(" ", "T") + "-08:00";
    const date = new Date(isoString);

    return isNaN(date.getTime()) ? null : date.getTime();
  } 
  
let endTime = getStoreEndTime(storeDateString);

function startTimer() {
  const timerEl = document.getElementById("timer");
  if (!timerEl) return;

  const interval = setInterval(() => {
    let now = Date.now();
    let remaining = endTime - now;

    if (remaining <= 0) {
      clearInterval(interval);
      timerEl.textContent = "Deal Ended";
      return;
    }

    const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
    const hrs = Math.floor((remaining / (1000 * 60 * 60)) % 24);
    const mins = Math.floor((remaining / (1000 * 60)) % 60);
    const secs = Math.floor((remaining / 1000) % 60);

    timerEl.textContent =
      `${days}d ${hrs.toString().padStart(2, "0")}h `
      + `${mins.toString().padStart(2, "0")}m `
      + `${secs.toString().padStart(2, "0")}s`;

  }, 1000);
}

document.addEventListener("DOMContentLoaded", startTimer);
document.addEventListener("cart:updated", startTimer);
document.addEventListener("drawer:open", startTimer);